/* Nährstoff-Check v2 (05.10.2026) – neues Design wie der Horizon-Shop, die elf Fragen unverändert (Ken: „genau so übernehmen“).
   Ablauf wie bisher: Start → Vorname → 11 Fragen (nach jeder eine kurze Reaktion) → E-Mail → Auswertung → Ergebnis.
   Neu ist nur das Ergebnis: das Advertorial zum wichtigsten Thema (nc-adv-<thema>.js, nachgeladen), jedes weitere Thema kompakt darunter.
   Themen kommen aus Frage 2 (Ziele) und Frage 11 (sonst noch) – alle angekreuzten, bis zu vier; Haut oder Haare entscheidet Frage 10;
   Rückfall bei weniger als zwei = alte Punkte.
   Unverändert: Schrittnummern 1–11 für die Absprung-Messung, melden() (eigener Zähler + Meta-CAPI „Lead“, Shopify-Analytics),
   Klaviyo-Liste XS6SR4 mit den alten Merkmalen nc_morgen … nc_sonstiges, Ereignis „Naehrstoff-Check: abgeschlossen“ mit denselben Feldern.
   Daten (Themen, Produkte) aus nc-daten.js, Advertorials aus nc-adv-*.js – beide erzeugt mit bau_quiz.py. */
(function () {
  "use strict";
  var NC_ZAEHLER = "https://putzfrauhh.de/nc-track";
  var KLAVIYO_TOKEN = "Uzz7GU", KLAVIYO_LISTE = "XS6SR4";
  var KATALOG = 55;
  var ZAHLWORT = ["null", "eins", "zwei", "drei", "vier", "fünf", "sechs", "sieben", "acht"];
  var ORDNUNG = ["", "zweites", "drittes", "viertes"];
  // Vorschau auf dem Rechner (vorschau/index.html setzt NC_VORSCHAU): nichts an Zähler, Meta oder Klaviyo senden
  var VORSCHAU = !!window.NC_VORSCHAU;
  var DATEN = window.NC_DATEN || { themen: [] };
  var THEMA = {};
  DATEN.themen.forEach(function (t) { THEMA[t.id] = t; });
  var LOGO = "https://cdn.shopify.com/s/files/1/0571/8196/2416/files/Surpresa_Natural_quer_f1801f9b-1787-40c9-ae8d-af9c74606eee.png?width=420";
  var ROSEMARY = "https://cdn.shopify.com/s/files/1/0571/8196/2416/files/nc-rosemary.jpg?v=1787944023";
  var HAKEN = '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path d="M4 10.5l4 4 8-9" fill="none" stroke="#4F7A32" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var HAKEN_WEISS = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M4 10.5l4 4 8-9" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var GESCHENK_SVG = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true" fill="none" stroke="#C2541A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4"/><path d="M5 12v8h14v-8"/><path d="M12 8v12"/><path d="M12 8c-1.5-3-5-3-5-1s3 1 5 1z"/><path d="M12 8c1.5-3 5-3 5-1s-3 1-5 1z"/></svg>';

  /* Die elf Fragen 1:1 aus dem Live-Quiz (Ken 05.10.: „die Fragen genau so übernehmen, die sind sehr gut“). a = [Symbol, Antwort, Reaktion] –
     das Symbol (Emoji) wird im neuen Design nicht mehr gezeigt. PUNKTE/WEIL wie bisher: für die Begründung im Ergebnis und als Rückfall. */
  var F = [
    {
      t: "Mal ehrlich \u2014 wie l\xE4uft dein Morgen?",
      a: [
        ["\u2600\uFE0F", "Direkt wach, kein Problem", "Selten hier{K}. Die meisten brauchen erst mal einen Moment."],
        [
          "\u2615",
          "Ohne Kaffee l\xE4uft nichts",
          "Willkommen im Club{K}. Kaffee l\xF6st es nur nicht \u2014 er verschiebt es auf nachmittags.",
        ],
        ["\u{1F40C}", "Ich komme nur langsam in Gang", "Kennen wir{K}. Der Tag braucht bei den meisten einen Anlauf."],
        [
          "\u{1F634}",
          "Ich bin schon m\xFCde, wenn ich aufstehe",
          "Verstanden{K}. Das ist kein Charakterfehler \u2014 es liegt seltener an der Schlafmenge, als man denkt.",
        ],
      ],
    },
    {
      t: "Was w\xFCrdest du gerne \xE4ndern?",
      u: "Wenn du am liebsten alles ankreuzen w\xFCrdest \u2014 das geht fast allen so. Nimm die, die gerade am meisten dr\xFCcken \u2014 eine reicht, zwei gehen auch.",
      multi: 2,
      mind: 1,
      a: [
        ["\u26A1", "Wieder mehr Energie haben"],
        ["\u{1F938}", "Beweglicher werden"],
        ["\u{1F4AA}", "Mehr Muskeln aufbauen"],
        ["\u{1F60C}", "Zur Ruhe kommen und besser schlafen"],
        ["\u2728", "Etwas f\xFCr Haut und Haare tun"],
        ["\u2696\uFE0F", "Mein Wohlf\xFChlgewicht"],
        ["\u{1F33F}", "Einfach allgemein gut versorgt sein"],
      ],
      paare: {
        0: "Der h\xE4ufigste Grund, warum jemand diesen Check macht. Und der, an dem im Alltag am meisten h\xE4ngt.",
        1: "Beweglichkeit f\xE4llt einem erst auf, wenn sie fehlt. Daf\xFCr dann jeden Tag.",
        2: "Daf\xFCr braucht der K\xF6rper Material \u2014 Training allein baut nichts auf.",
        3: "Der Punkt, an dem bei den meisten alles andere mit dranh\xE4ngt.",
        4: "Was man von au\xDFen sieht, wird innen gebaut. Deshalb dauert es dort auch l\xE4nger.",
        5: "Ein Thema mit viel L\xE4rm drumherum. Wir halten uns an das, was sich belegen l\xE4sst.",
        6: "Die vern\xFCnftigste Antwort von allen \u2014 und die seltenste.",
        "0-1": "Zwei Dinge, die sich gegenseitig bremsen. Wer sich schwerer bewegt, ist am Abend m\xFCder.",
        "0-2": "Muskeln aufbauen kostet erst mal Energie \u2014 und gibt langfristig mehr zur\xFCck, als es nimmt.",
        "0-3": "Das h\xE4ngt bei den meisten zusammen. Wer schlecht schl\xE4ft, hat selten Energie.",
        "0-4": "Zwei Dinge, die man selten zusammen denkt \u2014 die aber oft dieselbe Ursache haben.",
        "0-5": "Sehr h\xE4ufige Kombination. Meistens f\xE4ngt man beim Energie-Teil an, der Rest folgt dann leichter.",
        "1-2": "Gute Kombination. Das eine tr\xE4gt das andere.",
        "1-3": "Klingt nach einem K\xF6rper, der viel aush\xE4lt und wenig Pause bekommt.",
        "1-4": "Zwei Themen, die \xF6fter zusammen auftauchen, als man denkt \u2014 meist ab Mitte drei\xDFig.",
        "1-5": "Die beiden h\xE4ngen eng zusammen. Jedes Kilo weniger merken die Gelenke sofort.",
        "2-3": "Wird oft \xFCbersehen: Muskeln wachsen nicht im Training, sondern in der Nacht.",
        "2-4": "Klingt nach jemandem, der es rundherum ordentlich machen will. Selten, aber sinnvoll.",
        "2-5": "Die klassische Kombination. Und die einzige, bei der die Waage manchmal nichts zeigt, obwohl alles l\xE4uft.",
        "3-4": "Es hei\xDFt nicht umsonst Sch\xF6nheitsschlaf. Da ist tats\xE4chlich etwas dran.",
        "3-5": "Der Zusammenhang wird untersch\xE4tzt. Wer schlecht schl\xE4ft, hat am n\xE4chsten Tag mehr Hunger.",
        "4-5": "Beides Dinge, die man im Spiegel sieht. Und bei denen Geduld leider dazugeh\xF6rt.",
        6: "Die vern\xFCnftigste Antwort von allen. Und die, mit der man am wenigsten falsch macht.",
      },
    },
    {
      t: "Und wie sind deine N\xE4chte?",
      a: [
        ["\u{1F319}", "Ich schlafe durch", "Beneidenswert. Dann ist Schlaf bei dir schon mal nicht die Baustelle."],
        ["\u23F3", "Ich brauche lange zum Einschlafen", "Ein Klassiker. Und es liegt oft weniger am Kopf, als man denkt."],
        [
          "\u{1F31C}",
          "Ich wache nachts oft auf",
          "Sehr verbreitet \u2014 und meistens der Grund, warum der Morgen so anf\xE4ngt, wie du ihn beschrieben hast.",
        ],
        [
          "\u{1F4AD}",
          "Ich liege wach und die Gedanken kreisen",
          "Der K\xF6rper w\xE4re bereit, der Kopf nicht. Das sind zwei verschiedene Baustellen.",
        ],
      ],
    },
    {
      t: "Was fordert dich an einem normalen Tag mehr?",
      a: [
        [
          "\u{1F9E0}",
          "Der Kopf. Der ist immer an.",
          "Das ist die Sorte Anstrengung, die niemand sieht. Und die am schwersten abzustellen ist.",
        ],
        ["\u{1F3C3}", "Der K\xF6rper. Ich bin st\xE4ndig in Bewegung.", "Dann merkst du deinen Tag abends in den Beinen, nicht im Kopf."],
        ["\u{1F504}", "Beides gleicherma\xDFen.", "Die anstrengendste Mischung. Weil weder der Kopf noch der K\xF6rper mal Pause bekommt."],
        ["\u{1F33E}", "Mein Tag ist eher ruhig.", "Auch gut. Nicht jeder Tag muss ein Wettkampf sein."],
      ],
    },
    {
      t: "Und was machst du zum Ausgleich?",
      a: [
        ["\u{1F3CB}\uFE0F", "Kraft \u2014 Studio oder Hanteln zu Hause", "Dann hast du den Teil schon, den die meisten auslassen."],
        ["\u{1F6B4}", "Ausdauer \u2014 laufen, radfahren", "Gut f\xFCrs Herz \u2014 und der Kopf wird nebenbei leerer."],
        [
          "\u{1F6B6}",
          "Eher gem\xFCtlich \u2014 spazieren, Garten",
          "Wird untersch\xE4tzt. Regelm\xE4\xDFig spazieren schl\xE4gt zweimal im Jahr Marathon.",
        ],
        ["\u{1F6CB}\uFE0F", "Ehrlich gesagt gerade nichts", "Kein Grund, sich zu rechtfertigen. Die meisten Wochen sind einfach voll."],
      ],
    },
    {
      t: "Und wie isst du so?",
      a: [
        [
          "\u{1F969}",
          "Viel Eiwei\xDF \u2014 Fleisch und Fisch",
          "Damit hast du beim Eiwei\xDF keine L\xFCcke. Beim Rest schauen wir gleich genauer hin.",
        ],
        [
          "\u{1F957}",
          "Ich koche fast immer selbst, viel Gem\xFCse und Obst",
          "Das machen die wenigsten so konsequent. Bei dir geht es eher um Feinheiten als um L\xFCcken.",
        ],
        [
          "\u{1F37D}\uFE0F",
          "Ganz durchschnittlich \u2014 mal so, mal so",
          "Damit bist du in bester Gesellschaft. Mal l\xE4uft es besser, mal schlechter \u2014 so ist das.",
        ],
        ["\u{1F355}", "Ich koche selten. Meistens bestellen oder unterwegs", "So geht es vielen. Bei mir war es lange nicht anders."],
        [
          "\u{1F331}",
          "Ich esse vegetarisch oder vegan",
          "Wichtig zu wissen. Da r\xFCcken ein paar N\xE4hrstoffe nach vorn, die sonst kaum ein Thema sind.",
        ],
      ],
    },
    {
      t: "Und wie alt bist du?",
      u: "Der Bedarf verschiebt sich mit den Jahren \u2014 deshalb fragen wir.",
      ohne: 1,
      a: [
        ["", "18\u201329", "Fr\xFCh dran. Die meisten fangen erst an, wenn etwas zwickt."],
        ["", "30\u201344", "Die Jahre, in denen viele zum ersten Mal merken, dass sich etwas ver\xE4ndert."],
        ["", "45\u201359", "Da tut sich einiges. Und das meiste davon ist v\xF6llig normal."],
        ["", "60+", "Der Bedarf verschiebt sich in diesen Jahren, der Appetit oft auch."],
      ],
    },
    {
      t: "Und du bist\u2026",
      u: "Manche N\xE4hrstoffe braucht der K\xF6rper je nach Geschlecht unterschiedlich.",
      ohne: 1,
      a: [
        ["", "Frau", "Danke. Da gibt es ein paar Themen, die nur bei Frauen eine Rolle spielen."],
        ["", "Mann", "Danke. Da gibt es ein paar Themen, die nur bei M\xE4nnern eine Rolle spielen."],
        ["", "Sage ich lieber nicht", "Kein Problem. Dann rechnen wir ohne."],
      ],
    },
    {
      t: "Und wie l\xE4uft es mit der Beweglichkeit?",
      a: [
        [
          "\u{1F938}",
          "Alles locker, ich merke nichts",
          "Sch\xF6n. Dann m\xFCssen wir da nichts tun au\xDFer daf\xFCr sorgen, dass es so bleibt.",
        ],
        [
          "\u{1F305}",
          "Beim Loslaufen brauche ich einen Moment",
          "Das geht ganz vielen so. Meist morgens, und nach ein paar Minuten ist es weg.",
        ],
        [
          "\u2B06\uFE0F",
          "Treppen und Aufstehen merke ich schon",
          "Das sind genau die Momente, an denen man es zuerst merkt. Nicht beim Sport \u2014 im Alltag.",
        ],
        [
          "\u{1F5D3}\uFE0F",
          "Ich richte manches danach ein",
          "Das ist der Punkt, an dem es den Alltag ver\xE4ndert. Gut, dass du es sagst.",
        ],
      ],
    },
    {
      t: "F\xE4llt dir bei Haut oder Haaren gerade etwas auf?",
      u: "Wenn zwei Sachen zutreffen, kreuz beide an.",
      bis: 2,
      a: [
        ["\u{1F487}", "Meine Haare werden d\xFCnner", "F\xFCr die meisten ist das kein kleines Thema. Wir tun auch nicht so."],
        ["\u{1F4A7}", "Meine Haut ist oft trocken", "Trockene Haut hat fast jeder mal. Wenn sie bleibt, steckt meistens mehr dahinter."],
        [
          "\u{1F570}\uFE0F",
          "Erste F\xE4ltchen, weniger straff",
          "Passiert bei allen, ohne Ausnahme. Aufhalten geht nicht \u2014 sich darum k\xFCmmern schon.",
        ],
        ["\u{1F623}", "Unreine Haut, Pickel", "Das h\xF6rt nicht automatisch mit zwanzig auf. Bei vielen f\xE4ngt es da erst an."],
        ["\u{1F44D}", "Nein, alles in Ordnung", "Dann lassen wir das Thema aus. Nicht jeder braucht \xFCberall etwas."],
      ],
    },
    {
      t: "Gibt es sonst noch etwas, das dich besch\xE4ftigt?",
      u: "Wenn zwei Sachen zutreffen, kreuz beide an.",
      bis: 2,
      a: [
        ["\u{1F927}", "Ich bin oft erk\xE4ltet", "Kaum ist der eine weg, f\xE4ngt der n\xE4chste an. Und jedes Mal geht eine Woche drauf."],
        [
          "\u{1F34E}",
          "Meine Verdauung",
          "Nach dem Essen ist es am schlimmsten. Und irgendwann \xFCberlegt man, was man \xFCberhaupt noch isst.",
        ],
        [
          "\u{1F4A6}",
          "Blase und Harnwege",
          "Das Schlimmste daran ist, dass es immer wiederkommt. Und meistens dann, wenn es gerade gar nicht passt.",
        ],
        ["\u2705", "Nein, das war's", "Dann haben wir alles. Schauen wir uns an, was zu dir passt."],
      ],
    },
  ];
  var PUNKTE = {
    "0-1": { energie: 2 },
    "0-2": { energie: 3 },
    "0-3": { energie: 4, schlaf: 2 },
    "1-0": { energie: 5 },
    "1-1": { gelenke: 5 },
    "1-2": { muskeln: 5 },
    "1-3": { schlaf: 5 },
    "1-4": { haut: 5 },
    "1-5": { gewicht: 5 },
    "1-6": { grund: 6 },
    "2-1": { schlaf: 4 },
    "2-2": { schlaf: 4 },
    "2-3": { schlaf: 3, stress: 3 },
    "3-0": { stress: 3, energie: 2 },
    "3-1": { muskeln: 2, gelenke: 2 },
    "3-2": { stress: 2, energie: 2 },
    "4-0": { muskeln: 3 },
    "4-1": { energie: 1, gelenke: 1 },
    "4-3": { grund: 2 },
    "5-2": { grund: 2 },
    "5-3": { grund: 4 },
    "5-4": { grund: 2 },
    "6-2": { gelenke: 1, haut: 1 },
    "6-3": { gelenke: 2, haut: 1 },
    "8-1": { gelenke: 3 },
    "8-2": { gelenke: 4 },
    "8-3": { gelenke: 5 },
    "9-0": { haut: 5 },
    "9-1": { haut: 4 },
    "9-2": { haut: 4 },
    "9-3": { haut: 4 },
    "10-0": { immun: 5 },
    "10-1": { verdauung: 5 },
    "10-2": { blase: 5 },
  };
  var WEIL = {
    "0-2": "weil du morgens nur langsam in Gang kommst",
    "0-3": "weil du schon m\xFCde aufstehst",
    "1-0": "weil du wieder mehr Energie haben willst",
    "1-1": "weil du beweglicher werden willst",
    "1-2": "weil du Muskeln aufbauen willst",
    "1-3": "weil du zur Ruhe kommen und besser schlafen willst",
    "1-4": "weil du etwas f\xFCr Haut und Haare tun willst",
    "1-5": "weil du auf dein Wohlf\xFChlgewicht achtest",
    "1-6": "weil du allgemein gut versorgt sein willst",
    "2-1": "weil du lange zum Einschlafen brauchst",
    "2-2": "weil du nachts oft aufwachst",
    "2-3": "weil deine Gedanken nachts kreisen",
    "3-0": "weil dein Kopf den ganzen Tag l\xE4uft",
    "3-1": "weil dein Tag dich k\xF6rperlich fordert",
    "3-2": "weil dich Kopf und K\xF6rper gleicherma\xDFen fordern",
    "4-0": "weil du gezielt Kraft trainierst",
    "4-3": "weil gerade kein Sport drin ist",
    "5-2": "weil dein Speiseplan mal so, mal so aussieht",
    "5-3": "weil du selten kochst",
    "5-4": "weil du vegetarisch oder vegan isst",
    "6-2": "weil sich in deinem Jahrzehnt einiges verschiebt",
    "6-3": "weil sich der Bedarf mit den Jahren verschiebt",
    "8-1": "weil du beim Loslaufen einen Moment brauchst",
    "8-2": "weil du Treppen und Aufstehen schon merkst",
    "8-3": "weil du deinen Alltag schon danach einrichtest",
    "9-0": "weil dir auff\xE4llt, dass die Haare d\xFCnner werden",
    "9-1": "weil deine Haut oft trocken ist",
    "9-2": "weil du erste F\xE4ltchen bemerkst",
    "9-3": "weil dich unreine Haut besch\xE4ftigt",
    "10-0": "weil es dich oft erwischt",
    "10-1": "weil dich deine Verdauung besch\xE4ftigt",
    "10-2": "weil Blase und Harnwege ein Thema sind",
  };
  var START = -2, NAME = -1, MAIL = 11, ERGEBNIS = 12;
  // Alte Punkte-Themen → neue Advertorial-Themen
  var ALT_NEU = { energie: ["energie"], gelenke: ["gelenke"], muskeln: ["muskeln"], schlaf: ["schlaf"], stress: ["schlaf"], haut: ["haut", "haare"],
    gewicht: ["abnehmen"], immun: ["immunsystem"], verdauung: ["verdauung"], blase: ["blase"] };

  /* ---------- Sitzung und Herkunft (wie bisher) ---------- */
  var SITZUNG = (function () {
    try {
      var s = sessionStorage.getItem("nc_sid");
      if (!s) { s = "nc_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 9); sessionStorage.setItem("nc_sid", s); }
      return s;
    } catch (e) { return "nc_" + Date.now().toString(36); }
  })();
  var HERKUNFT = (function () {
    var felder = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid", "email", "kunde"];
    try {
      var g = JSON.parse(sessionStorage.getItem("nc_utm") || "null"), p = new URLSearchParams(location.search), neu = {}, gefunden = false;
      felder.forEach(function (f) { var w = p.get(f); if (w) { neu[f] = w; gefunden = true; } });
      if (gefunden) { sessionStorage.setItem("nc_utm", JSON.stringify(neu)); return neu; }
      return g || {};
    } catch (e) { return {}; }
  })();

  /* ---------- Klaviyo (wie bisher) ---------- */
  function klaviyoAnmelden(adresse, vorname, merkmale) {
    if (VORSCHAU) { console.log("[nc-vorschau] Klaviyo-Anmeldung", adresse, merkmale); return Promise.resolve(null); }
    try {
      var d = new URLSearchParams(), felder = ["$first_name", "nc_quelle"];
      d.append("g", KLAVIYO_LISTE); d.append("email", adresse);
      d.append("$first_name", vorname || ""); d.append("nc_quelle", "Naehrstoff-Check");
      Object.keys(merkmale || {}).forEach(function (k) { if (typeof merkmale[k] === "string") { felder.push(k); d.append(k, merkmale[k]); } });
      d.append("$fields", felder.join(","));
      return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
        method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: d.toString(), keepalive: true,
      }).then(function (r) { return r.json(); }).catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }
  function klaviyoEreignis(name, eigenschaften, kunde) {
    if (VORSCHAU) { console.log("[nc-vorschau] Klaviyo-Ereignis", name, eigenschaften, kunde); return Promise.resolve("0"); }
    try {
      var nutz = { token: KLAVIYO_TOKEN, event: "Naehrstoff-Check: " + name, customer_properties: kunde, properties: eigenschaften || {} };
      var b64 = btoa(unescape(encodeURIComponent(JSON.stringify(nutz))));
      return fetch("https://a.klaviyo.com/api/track?data=" + encodeURIComponent(b64), { mode: "cors", keepalive: true })
        .then(function (r) { return r.text(); }).catch(function () { return "0"; });
    } catch (e) { return Promise.resolve("0"); }
  }

  /* ---------- Messung (wie bisher) ---------- */
  function ncHash(t) {
    try {
      if (!t || !window.crypto || !crypto.subtle) return Promise.resolve("");
      var w = String(t).trim().toLowerCase();
      if (!w) return Promise.resolve("");
      return crypto.subtle.digest("SHA-256", new TextEncoder().encode(w)).then(function (b) {
        return Array.prototype.map.call(new Uint8Array(b), function (x) { return ("0" + x.toString(16)).slice(-2); }).join("");
      }).catch(function () { return ""; });
    } catch (e) { return Promise.resolve(""); }
  }
  function melden(ereignis, daten) {
    var d = Object.assign({ sitzung: SITZUNG, quiz: "naehrstoff-check" }, HERKUNFT, daten || {});
    if (VORSCHAU) { console.log("[nc-vorschau]", ereignis, d); return; }
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: "nc_" + ereignis }, d)); } catch (e) {}
    try { if (window.fbq) fbq("trackCustom", "NC_" + ereignis, d); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics) Shopify.analytics.publish("nc_schritt", {
        ereignis: ereignis, nummer: d.frage || 0, sitzung: SITZUNG, quelle: d.utm_source || "direkt", wert: d.summe || 0, anzahl: d.anzahl || 0,
      });
    } catch (e) {}
    try {
      if (NC_ZAEHLER) {
        var p = new URLSearchParams({ s: SITZUNG, e: ereignis, n: d.frage || 0, q: d.utm_source || "direkt", m: window.matchMedia("(max-width:780px)").matches ? "1" : "0" });
        if (d.fbclid) p.set("fbc", "fb.1." + Date.now() + "." + d.fbclid);
        var c = document.cookie.match(/_fbp=([^;]+)/);
        if (c) p.set("fbp", c[1]);
        var los = function () { new Image().src = NC_ZAEHLER + "?" + p.toString(); };
        if (d.email) {
          Promise.all([ncHash(d.email), ncHash(d.vorname)]).then(function (h) { if (h[0]) p.set("em", h[0]); if (h[1]) p.set("fn", h[1]); los(); }).catch(los);
        } else los();
      }
    } catch (e) {}
    if (window.NC_DEBUG) console.log("[nc]", ereignis, d);
  }

  /* ---------- Hilfen ---------- */
  var $ = function (id) { return document.getElementById(id); };
  var buehne = $("nc-buehne"), leiste = $("nc-leiste"), stand = $("nc-stand"), balken = $("nc-balken-i"), zurueck = $("nc-zurueck"), weiterLeiste = $("nc-weiter");
  var layer = $("nc-layer"), layerText = $("nc-layer-text");
  var wurzel = document.querySelector(".nc-q");
  var schritt = START, antworten = [], name = "", hoechster = -3, ladend = {}, uhr = null;
  function weiterZeigen(an) { weiterLeiste.classList.toggle("da", an); if (wurzel) wurzel.classList.toggle("mit-weiter", an); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function eur(n) { return (Math.round((n + Number.EPSILON) * 100) / 100).toFixed(2).replace(".", ",") + "\u00A0€"; }
  function anrede() { return name ? ", " + name : ""; }
  function gewaehltBei(f, i) { var a = antworten[f]; return a === undefined ? false : Array.isArray(a) ? a.indexOf(i) >= 0 : a === i; }
  function utm(thema) {
    var p = new URLSearchParams();
    p.set("utm_source", HERKUNFT.utm_source || "quiz");
    p.set("utm_medium", HERKUNFT.utm_medium || "onsite");
    p.set("utm_campaign", HERKUNFT.utm_campaign || "naehrstoff-check");
    p.set("utm_content", thema || "");
    if (HERKUNFT.utm_content) p.set("utm_term", HERKUNFT.utm_content);
    p.set("nc_sid", SITZUNG);
    return p.toString();
  }
  function ladeAdv(id) {
    if (window.NC_ADV && NC_ADV[id]) return Promise.resolve(NC_ADV[id]);
    if (ladend[id]) return ladend[id];
    ladend[id] = new Promise(function (ok, nein) {
      var url = (window.NC_ADV_URL || {})[id];
      if (!url) return nein(new Error("keine Adresse"));
      var s = document.createElement("script");
      s.src = url; s.async = true;
      s.onload = function () { (window.NC_ADV && NC_ADV[id]) ? ok(NC_ADV[id]) : nein(new Error("leer")); };
      s.onerror = function () { delete ladend[id]; nein(new Error("laden")); };
      document.head.appendChild(s);
    });
    return ladend[id];
  }
  // Während der Auswertung (gut 8 Sekunden) schon das Einstiegsfoto holen – sonst beginnt das Ergebnis mit einer weißen Lücke
  function fotoVorladen(id) {
    ladeAdv(id).then(function (html) {
      var m = /<img[^>]+src="([^"]+)"/.exec(html);
      if (m) new Image().src = m[1];
    }).catch(function () {});
  }

  /* ---------- Themen aus den Antworten (neu) ---------- */
  function punkteJeThema() {
    var punkte = {}, gruende = {};
    antworten.forEach(function (a, f) {
      (Array.isArray(a) ? a : [a]).forEach(function (i) {
        var p = PUNKTE[f + "-" + i];
        if (!p) return;
        Object.keys(p).forEach(function (alt) {
          (ALT_NEU[alt] || []).forEach(function (t) {
            punkte[t] = (punkte[t] || 0) + p[alt];
            var w = WEIL[f + "-" + i];
            if (w) { (gruende[t] = gruende[t] || []).push({ wert: p[alt], text: w }); }
          });
        });
      });
    });
    return { punkte: punkte, gruende: gruende };
  }
  function themenIds() {
    var liste = [], dazu = function (t) { if (t && THEMA[t] && liste.indexOf(t) < 0) liste.push(t); };
    var hautOderHaare = gewaehltBei(9, 0) ? "haare" : "haut";
    var ZIEL = { 0: "energie", 1: "gelenke", 2: "muskeln", 3: "schlaf", 4: hautOderHaare, 5: "abnehmen" };
    (Array.isArray(antworten[1]) ? antworten[1] : []).forEach(function (j) { dazu(ZIEL[j]); });          // Frage 2: Ziele, in Klick-Reihenfolge
    var SONST = { 0: "immunsystem", 1: "verdauung", 2: "blase" };
    (Array.isArray(antworten[10]) ? antworten[10] : []).forEach(function (j) { dazu(SONST[j]); });      // Frage 11: sonst noch
    // Wer etwas ausdrücklich ankreuzt (Frage 2 und 11), bekommt es garantiert – bis zu vier Themen, nichts wird abgeschnitten.
    // Nur wenn es weniger als zwei sind, füllen die alten Punkte auf zwei auf.
    if (liste.length < 2) {
      var P = punkteJeThema().punkte;
      Object.keys(P).filter(function (t) { return P[t] > 0; }).sort(function (a, b) { return P[b] - P[a]; })
        .forEach(function (t) { if (liste.length < 2) dazu(t); });
    }
    if (!liste.length) liste.push("energie");
    return liste;
  }
  function themen() { return themenIds().map(function (id) { return THEMA[id]; }); }
  function haupt() { return themen()[0]; }

  /* ---------- Kopfleiste ---------- */
  function kopf() {
    var frage = schritt >= 0 && schritt <= 10;
    leiste.classList.toggle("start", schritt === START || schritt === ERGEBNIS);
    if (schritt === NAME) stand.textContent = "Los geht’s";
    else if (frage) stand.textContent = "Frage " + (schritt + 1) + " von 11";
    else if (schritt === MAIL) stand.textContent = "Fast fertig";
    var p = schritt === MAIL ? 95 : schritt >= 0 ? Math.round(((schritt + 1) / 12) * 100) : 3;
    balken.style.width = p + "%";
    zurueck.hidden = !(schritt > 0 && schritt <= MAIL);
    weiterZeigen(false);
  }

  function zeichnen() {
    clearTimeout(uhr);
    layer.classList.remove("da", "laeuft");
    kopf();
    if (schritt > hoechster) {
      hoechster = schritt;
      if (schritt >= 0 && schritt <= 10) melden("frage_gesehen", { frage: schritt + 1, titel: F[schritt].t });
      else if (schritt === MAIL) melden("mailfeld_gesehen", {});
    }
    window.scrollTo({ top: 0, behavior: "instant" });
    buehne.classList.toggle("ergebnis", schritt === ERGEBNIS);
    if (schritt === START) return start();
    if (schritt === NAME) return namensfrage();
    if (schritt === MAIL) return mail();
    if (schritt === ERGEBNIS) return ergebnis();
    frage(schritt);
  }

  /* ---------- Start ---------- */
  function start() {
    buehne.innerHTML =
      '<div class="nc-start">' +
      '<p class="oberzeile">Nährstoff-Check</p>' +
      "<h1>Welche Nährstoffe passen wirklich zu dir?</h1>" +
      '<p class="sub">Elf Fragen zu deinem Alltag. Danach weißt du, was zu dir passt – und was nicht.</p>' +
      '<button class="knopf" id="nc-los">Zeig mir, was zu mir passt</button>' +
      '<p class="mini">Keine zwei Minuten.</p>' +
      '<div class="nc-geschenk">' + GESCHENK_SVG + "<span>Am Ende erwartet dich ein Geschenk.</span></div>" +
      '<ul class="nc-vertrauen"><li>' + HAKEN + "Aus Schleswig-Holstein, seit 2011</li><li>" + HAKEN + "Laborgeprüft</li><li>" + HAKEN +
      "Versandkostenfrei ab 29 €</li><li>" + HAKEN + "180 Tage Geld zurück</li></ul>" +
      '<div class="nc-stimme"><img src="' + ROSEMARY + '" alt="Rosemary"><p>Die meisten kaufen das Falsche – nicht weil sie schlecht beraten sind, sondern weil ihnen nie jemand die richtigen Fragen gestellt hat. Genau dafür gibt es diesen Check.<b>Rosemary · Surpresa Natural</b></p></div>' +
      "</div>";
    melden("seite", {});
    $("nc-los").onclick = function () { melden("start", {}); schritt = NAME; zeichnen(); };
  }

  /* ---------- Vorname (wie bisher) ---------- */
  function namensfrage() {
    buehne.innerHTML =
      '<div class="nc-frage nc-name"><h2>Bevor wir loslegen – wie sollen wir dich nennen?</h2>' +
      '<p class="unter">Der Vorname reicht. Damit die Antworten nicht klingen wie ein Formular.</p>' +
      '<label class="nc-feld"><span>Dein Vorname</span><input id="nc-namensfeld" type="text" autocomplete="given-name" maxlength="24"></label>' +
      '<button class="knopf" id="nc-name-weiter">Weiter</button>' +
      '<p class="nc-ohne"><button class="textknopf" id="nc-ohne-namen" type="button">lieber ohne Namen</button></p></div>';
    var feld = $("nc-namensfeld");
    feld.value = name;
    feld.focus();
    var los = function () { name = feld.value.trim().replace(/[<>]/g, "").slice(0, 24); schritt = 0; zeichnen(); };
    $("nc-name-weiter").onclick = los;
    feld.onkeydown = function (e) { if (e.key === "Enter") los(); };
    $("nc-ohne-namen").onclick = function () { name = ""; schritt = 0; zeichnen(); };
  }

  /* ---------- Fragen (Regeln wie bisher) ---------- */
  function frage(i) {
    var f = F[i], multi = f.multi || 0, bis = f.bis || 0, mind = f.mind || 0, mehr = multi || bis;
    var h = '<div class="nc-frage"><h2' + (f.u ? "" : ' class="allein"') + ">" + esc(f.t) + "</h2>";
    if (f.u) h += '<p class="unter">' + esc(f.u) + "</p>";
    f.a.forEach(function (a, j) {
      h += '<button class="nc-wahl' + (mehr ? " mehr" : "") + '" data-j="' + j + '">' + esc(a[1]) + '<span class="marke">' + HAKEN_WEISS + "</span></button>";
    });
    if (mehr) h += '<p class="nc-hinweis" id="nc-hinweis"></p>';
    h += "</div>";
    buehne.innerHTML = h;
    var knoepfe = buehne.querySelectorAll(".nc-wahl");

    if (!mehr) {
      if (antworten[i] != null && knoepfe[antworten[i]]) knoepfe[antworten[i]].classList.add("an");
      knoepfe.forEach(function (b) {
        b.onclick = function () {
          var j = +b.dataset.j;
          knoepfe.forEach(function (x) { x.classList.toggle("an", x === b); });
          antworten[i] = j;
          melden("antwort", { frage: i + 1, antwort: j + 1, text: f.a[j][1] });
          melde(f.a[j][2]);
        };
      });
      return;
    }

    var letzte = f.a.length - 1, hinweis = $("nc-hinweis");
    var gew = Array.isArray(antworten[i]) ? antworten[i].slice() : [];
    var zeigen = function () {
      knoepfe.forEach(function (b) {
        var pos = gew.indexOf(+b.dataset.j);
        b.classList.toggle("an", pos >= 0);
        b.querySelector(".marke").innerHTML = pos >= 0 ? (multi ? String(pos + 1) : HAKEN_WEISS) : "";
      });
      weiterZeigen(gew.length > 0);
      var offen = mehr - gew.length;
      hinweis.textContent = multi
        ? (offen === multi ? (mind ? "Wähle eine oder zwei" : "Wähle 2 aus") : offen ? (mind ? "Eine zweite geht noch – oder weiter" : "Noch eine – dann geht es weiter") : "2 von 2 gewählt")
        : (gew.length ? "" : "Bis zu zwei Antworten");
    };
    var abschicken = function () {
      antworten[i] = gew.slice();
      melden("antwort", { frage: i + 1, antwort: gew.map(function (x) { return x + 1; }).join("+"), text: gew.map(function (x) { return f.a[x][1]; }).join(" + ") });
      weiterZeigen(false);
      if (bis) { melde(f.a[gew[0]][2] || ""); return; }
      var key = gew.indexOf(letzte) >= 0 ? String(letzte) : gew.slice().sort(function (a, b) { return a - b; }).join("-");
      melde((f.paare && f.paare[key]) || "");
    };
    knoepfe.forEach(function (b) {
      b.onclick = function () {
        var j = +b.dataset.j;
        if (j === letzte) gew = [letzte];
        else if (gew.indexOf(letzte) >= 0) gew = [j];
        else if (gew.indexOf(j) >= 0) gew = gew.filter(function (x) { return x !== j; });
        else if (gew.length < mehr) gew.push(j);
        else return;
        zeigen();
        if (gew.indexOf(letzte) >= 0 || gew.length === mehr) abschicken();
      };
    });
    $("nc-weiter-knopf").onclick = function () { if (gew.length) abschicken(); };
    zeigen();
  }
  // Kurze Reaktion nach jeder Antwort (Texte wie bisher), dann automatisch weiter
  function melde(text) {
    layerText.textContent = String(text || "").replace("{K}", anrede());
    layer.classList.add("da");
    requestAnimationFrame(function () { layer.classList.add("laeuft"); });
    uhr = setTimeout(weiter, 2300);
    // Advertorials des wahrscheinlichen Ergebnisses schon im Hintergrund laden
    if (schritt >= 1) themenIds().forEach(function (t) { ladeAdv(t).catch(function () {}); });
  }
  function weiter() { clearTimeout(uhr); schritt++; zeichnen(); }

  /* ---------- E-Mail (Texte wie bisher, Optik neu) ---------- */
  var TIPPFEHLER = {
    "gmail.de": "gmail.com", "gmail.con": "gmail.com", "gmail.co": "gmail.com", "gmial.com": "gmail.com", "gmai.com": "gmail.com", "gmali.com": "gmail.com",
    "gmaill.com": "gmail.com", "gmail.comm": "gmail.com", "googlemail.de": "googlemail.com", "hotmai.de": "hotmail.de", "hotmial.de": "hotmail.de",
    "hotmail.con": "hotmail.de", "hotmail.de.de": "hotmail.de", "outlok.de": "outlook.de", "outlook.con": "outlook.de", "yaho.de": "yahoo.de",
    "yahooo.de": "yahoo.de", "yahoo.con": "yahoo.de", "web.d": "web.de", "web.de.de": "web.de", "wed.de": "web.de", "gmx.d": "gmx.de", "gmx.ed": "gmx.de",
    "gmx.net.de": "gmx.net", "t-onlien.de": "t-online.de", "t-online.d": "t-online.de", "icloud.con": "icloud.com", "icloud.de": "icloud.com",
  };
  function mail() {
    var anzahl = produkteListe().length;
    buehne.innerHTML =
      '<div class="nc-mail"><h2>Geschafft' + esc(anrede()) + ".</h2>" +
      '<p class="unter">' + (HERKUNFT.email ? "Deine Adresse habe ich schon – prüf kurz, ob sie stimmt, dann geht es zum Ergebnis." :
        "Du hast dir gerade zwei Minuten für dich genommen – das machen die wenigsten. Sag mir noch deine Adresse, dann zeige ich dir das Ergebnis.") + "</p>" +
      '<div class="nc-fertig">' + (name ? esc(name) + ", von " : "Von ") + "unseren " + KATALOG + " Produkten passen <b>" + (ZAHLWORT[anzahl] || anzahl) +
      "</b> zu dir. Deine Auswertung ist fertig." +
      '<div class="geschenkzeile">' + GESCHENK_SVG + "<span>Nach der Auswertung bekommst du per E-Mail ein Geschenk.</span></div></div>" +
      '<label class="nc-feld"><span>Deine E-Mail-Adresse</span><input type="email" id="nc-mailfeld" placeholder="deine@e-mail.de" autocomplete="email" inputmode="email" autocapitalize="off" autocorrect="off" spellcheck="false" value="' + esc(HERKUNFT.email || "") + '"></label>' +
      '<p class="nc-fehler" id="nc-mailfehler"></p>' +
      '<p class="nc-einwilligung">Du bekommst deine Auswertung per Mail – und ab und zu einen Tipp. Jederzeit mit einem Klick abbestellbar.</p>' +
      '<button class="knopf" id="nc-senden">' + (HERKUNFT.email ? "Stimmt – zeig mir das Ergebnis" : "Auswertung ansehen") + "</button>" +
      '<p class="danke">Danke für dein Vertrauen. Deine Adresse bleibt bei uns – wir geben sie an niemanden weiter und verkaufen sie schon gar nicht.</p>' +
      '<div class="nc-stimme"><img src="' + ROSEMARY + '" alt="Rosemary"><p>Was gleich kommt, habe ich mir wirklich angeschaut – nicht der Computer allein. Und ich schreibe dir nur das hin, was ich auch meiner Schwester empfehlen würde.<b>Rosemary · Surpresa Natural</b></p></div></div>';

    var feld = $("nc-mailfeld"), fehlerZeile = $("nc-mailfehler"), tippGesehen = false;
    var fehler = function (html) { fehlerZeile.innerHTML = html; fehlerZeile.style.display = "block"; feld.classList.add("fehler"); };
    var fehlerWeg = function () { fehlerZeile.style.display = "none"; fehlerZeile.innerHTML = ""; feld.classList.remove("fehler"); };
    $("nc-senden").onclick = function () {
      var adresse = feld.value.trim().toLowerCase();
      if (!adresse) { fehler("Ohne Adresse können wir dir die Auswertung nicht schicken."); feld.focus(); melden("mail_ungueltig", { grund: "leer" }); return; }
      if (!/^[^\s@]+@([^\s@.]+\.)+[a-z]{2,}$/i.test(adresse)) {
        fehler(adresse.indexOf("@") < 0 ? "Da fehlt noch das @ in der Adresse." : "Die Adresse sieht noch nicht vollständig aus – prüf sie bitte einmal.");
        feld.focus(); melden("mail_ungueltig", { grund: "form" }); return;
      }
      var teil = adresse.split("@"), richtig = TIPPFEHLER[teil[1]];
      if (richtig && !tippGesehen) {
        tippGesehen = true;
        var vorschlag = teil[0] + "@" + richtig;
        fehler("Meintest du <b>" + esc(vorschlag) + '</b>? <button type="button" id="nc-tippfix">Ja, ändern</button>');
        feld.classList.remove("fehler");
        $("nc-tippfix").onclick = function () { feld.value = vorschlag; fehlerWeg(); $("nc-senden").click(); };
        melden("mail_tippfehler", { vorschlag: richtig });
        return;
      }
      fehlerWeg();
      abschicken(adresse);
    };
    feld.addEventListener("input", fehlerWeg);
    feld.addEventListener("keydown", function (e) { if (e.key === "Enter") $("nc-senden").click(); });
    if (!HERKUNFT.email) feld.focus();
  }

  /* Für die Auswertungsmail (Flow U2qu8v): je Dose
     grund   = persönlicher Grund aus den Antworten wie im alten Quiz („Weil du …“) – die Mail verspricht „ich schreibe dir bei jedem dazu, warum“;
               erste Dose des Themas bekommt den stärksten Grund, die zweite den nächsten (sonst denselben)
     schmerz = die Aufgabe der Dose im Duo (je Dose verschieden – vorher stand hier bei beiden Dosen dieselbe Überschrift) */
  function produkteListe() {
    var liste = [], gesehen = {};
    themen().forEach(function (t, ti) {
      var gr = gruendeFuer(t.id);
      t.karten.forEach(function (k, ki) {
        if (gesehen[k.handle]) return;
        gesehen[k.handle] = 1;
        var weil = gr[ki] || gr[0] || "";
        liste.push({
          key: k.handle, name: k.name, preis: k.preis, preis_text: eur(k.preis), bild: k.bild + "&width=300",
          grund: weil ? "Weil" + weil.slice(4) : "Passt zu deinen Antworten",
          schmerz: k.aufgabe, rolle: k.rolle, claim: k.claim, stufe: (ti === 0 ? "Dein Thema: " : "Dein " + ORDNUNG[ti] + " Thema: ") + t.titel,
          empfohlen: "ja", url: "https://surpresanatural.de/products/" + k.handle + "?utm_source=quiz&utm_medium=email&utm_campaign=naehrstoff-check&utm_content=" + t.id,
        });
      });
    });
    return liste;
  }
  // Wie im alten Quiz: 15 % ab 3 Dosen, 20 % ab 5 – nur hier vergeben, damit jede Bestellung mit dem Code sicher aus dem Check stammt.
  // Die Auswertungsmail zeigt „Dein Check-Rabatt ist im Link schon eingelöst“, Mail 2 „dein Code gilt weiterhin“.
  function rabattCode(anzahl) { return anzahl >= 5 ? "CHECK20" : anzahl >= 3 ? "CHECK15" : ""; }
  function korbLink(produkte, code) {
    var vids = {};
    themen().forEach(function (t) { t.karten.forEach(function (k) { vids[k.handle] = k.vid; }); });
    return "/cart/" + produkte.map(function (p) { return vids[p.key] + ":1"; }).join(",") + "?" + (code ? "discount=" + code + "&" : "") + utm(themenIds().join("-"));
  }
  function herkunftName() {
    var q = String(HERKUNFT.utm_source || "").toLowerCase();
    if (HERKUNFT.fbclid || /facebook|instagram|^fb$|^ig$|meta/.test(q)) return "Facebook & Instagram";
    if (/klaviyo|email|newsletter|mail/.test(q)) return "E-Mail / Newsletter";
    if (HERKUNFT.gclid || /google|bing|ecosia|duckduck|organic|suche/.test(q)) return "Suche / organisch";
    if (!q || /quiz|direkt|direct/.test(q)) return "Direkt";
    return q;
  }
  function merkmale(produkte) {
    var FELD = ["nc_morgen", "nc_ziel", "nc_nacht", "nc_tag", "nc_ausgleich", "nc_ernaehrung", "nc_alter", "nc_geschlecht", "nc_beweglichkeit", "nc_haut_haare", "nc_sonstiges"];
    var m = {};
    antworten.forEach(function (a, f) {
      if (a === undefined || !F[f]) return;
      m[FELD[f]] = Array.isArray(a) ? a.map(function (i) { return F[f].a[i][1]; }).join(" + ") : F[f].a[a][1];
    });
    var namen = themen().map(function (t) { return t.titel; });
    m.nc_empfehlung = produkte.map(function (p) { return p.name; }).join(", ");
    m.nc_top_themen = namen.join(", ");
    m.nc_hauptthema = namen[0] || "";
    m.nc_vegan = gewaehltBei(5, 4) ? "ja" : "nein";
    m.nc_version = "v2-design";
    m.nc_abgeschlossen_am = new Date().toISOString().slice(0, 10);
    m.nc_herkunft = herkunftName();
    m.nc_kampagne = HERKUNFT.utm_campaign || "";
    m.nc_anzeige = HERKUNFT.utm_content || "";
    return m;
  }
  // Gratis-Dose ab 49 € (automatischer Shopify-Rabatt „Gratis-Geschenk ab 49 €“): nur für Magnesium Natürlich, Vitamin C Acerola, Glucosamin
  // MSM, Omega 3 Plus, Kreatin, Multivitamin, Vitamin B Komplex – und die übrigen Dosen müssen ohne die Gratis-Dose mindestens 49 € kosten
  // (vor dem Check-Rabatt). In der Kasse geprüft 05.10.2026; geschenkt wird die günstigste passende Dose.
  var GESCHENK_DOSEN = ["vitamin-b-komplex", "glucosamin-chondroitin-msm-180-kapseln-hochdosiert", "omega-3-120-capsules", "kreatin", "natural-vitamin-c-180-kapseln"];
  function geschenkDose(produkte) {
    var summe = produkte.reduce(function (s, p) { return s + p.preis; }, 0);
    var k = produkte.filter(function (p) { return GESCHENK_DOSEN.indexOf(p.key) >= 0; }).sort(function (a, b) { return a.preis - b.preis; });
    return k.length && Math.round((summe - k[0].preis) * 100) >= 4900 ? k[0] : null;
  }

  /* ---------- Ergebnis-Link für die Auswertungsmail ----------
     Die Mail führt mit …/pages/naehrstoff-check?nc=<code> genau auf diese Ergebnisseite zurück. Der Code enthält die elf Antworten und den
     Vornamen (Base64, kein Klartext). layout/nc.liquid nimmt ihn aus der Adresse, bevor die Messdienste sie lesen (sessionStorage nc_ergebnis). */
  function ergebnisCode() {
    var roh = "1|" + antworten.map(function (a) { return Array.isArray(a) ? a.join(".") : a == null ? "" : String(a); }).join("_") + "|" + (name || "");
    return btoa(unescape(encodeURIComponent(roh))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }
  function codeLesen(code) {
    try {
      var t = decodeURIComponent(escape(atob(String(code).replace(/-/g, "+").replace(/_/g, "/")))).split("|");
      if (t[0] !== "1" || t.length < 2) return null;
      var teile = t[1].split("_"), a = [];
      if (teile.length !== F.length) return null;
      for (var i = 0; i < F.length; i++) {
        var f = F[i], mehr = f.multi || f.bis || 0;
        if (teile[i] === "") return null;
        var w = teile[i].split(".").map(Number);
        if (w.some(function (x) { return !(x >= 0 && x < f.a.length && Math.floor(x) === x); })) return null;
        if (mehr ? w.length > mehr : w.length !== 1) return null;
        a.push(mehr ? w : w[0]);
      }
      return { antworten: a, name: t.slice(2).join("|").replace(/[<>]/g, "").slice(0, 24) };
    } catch (e) { return null; }
  }
  function linkLesen() {
    var code = null;
    try { code = sessionStorage.getItem("nc_ergebnis"); } catch (e) {}
    if (!code) code = new URLSearchParams(location.search).get("nc");
    return code ? codeLesen(code) : null;
  }
  function ergebnisLink() {
    var p = new URLSearchParams();
    p.set("nc", ergebnisCode());
    p.set("utm_source", "quiz"); p.set("utm_medium", "email"); p.set("utm_campaign", "naehrstoff-check"); p.set("utm_content", themenIds().join("-"));
    // Test in der Theme-Vorschau: der Link öffnet dieselbe Vorschau (im Live-Theme gibt es den Zusatz nicht)
    try { if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== "main") p.set("preview_theme_id", Shopify.theme.id); } catch (e) {}
    return location.origin + location.pathname + "?" + p.toString();
  }

  // Alles, was nach dem Absenden an Klaviyo geht (Ereignis „Naehrstoff-Check: abgeschlossen“ → Flow U2qu8v)
  function mailDaten(adresse) {
    var produkte = produkteListe(), m = merkmale(produkte), summe = produkte.reduce(function (s, p) { return s + p.preis; }, 0);
    var code = rabattCode(produkte.length), link = location.origin + korbLink(produkte, code), h = haupt(), g = geschenkDose(produkte);
    return {
      produkte: produkte, merkmale: m, summe: summe, code: code, korb: link,
      eigenschaften: {
        kunde: HERKUNFT.kunde || "", produkte: produkte, anzahl_empfohlen: produkte.length, summe_empfohlen: summe.toFixed(2),
        summe_empfohlen_text: eur(summe), rabattcode: code, vorname: name || "", newsletter: "ja", korb_link: link,
        themen: themenIds().join(","), hauptthema: h.titel,
        // Auswertungsmail im Shop-Design: derselbe Einstieg wie auf der Ergebnisseite und der Link dorthin
        ergebnis_link: ergebnisLink(), haupt_titel: h.titel,
        // für Rabatt-Links in den Nachfass-Mails: /discount/START10?redirect={{ event.ergebnis_pfad }} (setzt den Code, öffnet die Ergebnisseite)
        ergebnis_pfad: encodeURIComponent(ergebnisLink().replace(location.origin, "")), haupt_h1: h.h1, haupt_text: h.unterzeile, haupt_bild: h.foto + "?width=1140",
        haupt_bild_alt: h.foto_alt, persoenlich: kastenSaetze(false), geschenk: g ? "ja" : "nein", geschenk_dose: g ? g.name : "",
      },
      kunde: Object.assign({ $email: adresse, $first_name: name || undefined, $consent: ["email"] }, m),
    };
  }
  function abschicken(adresse) {
    var d = mailDaten(adresse);
    melden("abgeschlossen", Object.assign({
      email: adresse, newsletter: "ja", vorname: name || "", produkte: d.produkte, anzahl_empfohlen: d.produkte.length,
      summe_empfohlen: d.summe.toFixed(2), summe_empfohlen_text: eur(d.summe), rabattcode: d.code, korb_link: d.korb, themen: themenIds().join(","),
    }, d.merkmale));
    klaviyoAnmelden(adresse, name, d.merkmale);
    klaviyoEreignis("abgeschlossen", d.eigenschaften, d.kunde);
    analyse();
  }

  /* ---------- Auswertung läuft (Texte wie bisher) ---------- */
  var A_SCHRITTE = [["Deine elf Antworten werden gelesen", 1900], ["Abgleich mit " + KATALOG + " Produkten", 2400], ["Nährstoffe werden nach Wichtigkeit sortiert", 2300], ["Deine Auswertung wird zusammengestellt", 1600]];
  function analyse() {
    var box = $("nc-analyse"), liste = $("nc-a-schritte"), bar = $("nc-a-bar"), titel = $("nc-a-titel");
    liste.innerHTML = A_SCHRITTE.map(function (x, i) { return '<li data-i="' + i + '"><span class="k">' + HAKEN_WEISS + "</span>" + esc(x[0]) + "</li>"; }).join("");
    titel.textContent = "Deine Auswertung wird erstellt";
    bar.style.width = "0%";
    box.classList.add("da");
    fotoVorladen(themenIds()[0]);
    window.scrollTo({ top: 0, behavior: "instant" });
    var gesamt = A_SCHRITTE.reduce(function (a, x) { return a + x[1]; }, 0), t0 = performance.now();
    var lauf = setInterval(function () { bar.style.width = Math.min(100, Math.round(((performance.now() - t0) / gesamt) * 100)) + "%"; }, 90);
    var bisher = 0;
    A_SCHRITTE.forEach(function (x, i) {
      var el = function () { return liste.querySelector('[data-i="' + i + '"]'); };
      setTimeout(function () { var e = el(); if (e) e.classList.add("laeuft"); }, bisher);
      bisher += x[1];
      setTimeout(function () { var e = el(); if (e) { e.classList.remove("laeuft"); e.classList.add("fertig"); } }, bisher);
    });
    setTimeout(function () {
      clearInterval(lauf); bar.style.width = "100%"; titel.textContent = "Fertig.";
      setTimeout(function () { box.classList.remove("da"); schritt = ERGEBNIS; zeichnen(); }, 550);
    }, gesamt);
  }

  /* ---------- Ergebnis (neu: Advertorial zum Thema) ---------- */
  function karteHtml(k) {
    return '<div class="produkt-karte"><div class="rolle">' + esc(k.rolle) + '</div><img src="' + k.bild + '&width=400" width="400" height="400" loading="lazy" alt="Dose ' +
      esc(k.name) + '"><h3>' + k.name_html + "</h3><p>" + k.text + '</p><div class="ab-preis">ab ' + esc(k.ab) + ' € pro Dose</div>' +
      '<a class="knopf" data-nc-produkt="1" href="https://surpresanatural.de/products/' + k.handle + '">' + esc(k.knopf) + "</a></div>";
  }
  function gruendeFuer(id) {   // „weil …“-Texte aus den Antworten, stärkster zuerst, ohne Doppelte
    var g = (punkteJeThema().gruende[id] || []).sort(function (a, b) { return b.wert - a.wert; });
    var texte = [];
    g.forEach(function (x) { if (texte.indexOf(x.text) < 0) texte.push(x.text); });
    return texte;
  }
  function begruendung(id, nurEine) {
    var texte = gruendeFuer(id).slice(0, nurEine ? 1 : 2);
    if (!texte.length) return "";
    return texte[0] + (texte[1] ? " und " + texte[1].replace(/^weil (du )?/, "") : "");
  }
  // Sätze im Kasten „Was deine Antworten sagen“ – als HTML für die Seite (mit Sprungmarken) oder als Text für die Auswertungsmail
  function kastenSaetze(html) {
    var s = [], ts = themen(), extra = ts.slice(1);
    var e = html ? esc : function (x) { return String(x); };
    var marke = function (t, i) { return html ? '<a href="#nc-zweit-' + i + '">' + esc(t.titel) + "</a>" : t.titel; };
    var b1 = begruendung(ts[0].id);
    s.push((name ? e(name) + ", dein" : "Dein") + " wichtigstes Thema ist " + (html ? "<b>" + esc(ts[0].titel) + "</b>" : ts[0].titel) + (b1 ? " – " + e(b1) : "") + ".");
    if (extra.length === 1) {
      var b2 = begruendung(extra[0].id);
      s.push("Dazu kommt " + marke(extra[0], 1) + (b2 ? ", " + e(b2) : "") + ". Das findest du weiter unten.");
    } else if (extra.length > 1) {
      // „Dazu kommen Gelenke, weil …, und Blase, weil … .“ – je Thema nur der wichtigste Grund, sonst wird der Satz zu lang
      var gr = extra.map(function (t) { return begruendung(t.id, true); }), satz = "";
      extra.forEach(function (t, i) {
        if (i > 0) satz += i < extra.length - 1 ? ", " : (gr[i - 1] ? ", und " : " und ");
        satz += marke(t, i + 1) + (gr[i] ? ", " + e(gr[i]) : "");
      });
      s.push("Dazu kommen " + satz + ". " + (extra.length === 2 ? "Beides" : "Alles") + " findest du weiter unten.");
    }
    if (gewaehltBei(5, 4)) {
      var hinweise = [];
      ts.forEach(function (t) { t.karten.forEach(function (k) { if (k.hinweis_vegan && hinweise.indexOf(k.hinweis_vegan) < 0) hinweise.push(k.hinweis_vegan); }); });
      if (hinweise.length) s.push(html ? "<b>Ehrlicher Hinweis, weil du vegetarisch oder vegan isst:</b> " + hinweise.join(" ")
        : "Ehrlicher Hinweis, weil du vegetarisch oder vegan isst: " + hinweise.join(" ").replace(/<[^>]+>/g, "").replace(/&amp;/g, "&"));
    }
    return s;
  }
  function persoenlich() {
    return '<section class="abschnitt" style="padding:4px 0 0"><div class="wrap"><div class="kasten nc-persoenlich"><p class="titel">Was deine Antworten sagen</p>' +
      kastenSaetze(true).map(function (x) { return "<p>" + x + "</p>"; }).join("") + "</div></div></section>";
  }
  function zweitBlock(t, nr) {   // nr 1–3 = zweites bis viertes Thema
    return '<section class="abschnitt creme nc-zweit" id="nc-zweit-' + nr + '" data-thema="' + t.id + '"><div class="weit"><div class="wrap angebot-kopf" style="padding:0">' +
      '<div class="oberzeile">Dein ' + ORDNUNG[nr] + " Thema · " + esc(t.titel) + "</div><h2>" + t.h1 + "</h2><p>" + t.unterzeile + "</p></div>" +
      '<div class="produkte">' + t.karten.map(karteHtml).join("") + "</div>" +
      '<div class="wrap" style="padding:0"><button class="knopf-hell nc-mehr" data-nr="' + nr + '">Die ganze Erklärung zu ' + esc(t.titel) + " lesen</button></div></div></section>" +
      '<div class="nc-zweit-voll" id="nc-zweit-voll-' + nr + '"></div>';
  }
  function linksVorbereiten(bereichWurzel) {
    bereichWurzel.querySelectorAll("a[data-nc-produkt]").forEach(function (a) {
      if (a.dataset.fertig) return;
      a.dataset.fertig = "1";
      var bereich = a.closest('[id^="angebot-"], .nc-zweit');
      var thema = bereich ? (bereich.dataset.thema || bereich.id.replace("angebot-", "")) : "";
      var handle = a.getAttribute("href").split("/products/")[1].split("?")[0];
      a.href = "https://surpresanatural.de/products/" + handle + "?" + utm(thema);
      a.addEventListener("click", function () { melden(AUS_LINK ? "link_warenkorb" : "warenkorb", { produkte: handle, anzahl: 1, ort: "produktkarte", thema: thema }); });
    });
    bereichWurzel.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (ev) {
        var ziel = document.getElementById(a.getAttribute("href").slice(1));
        if (ziel) { ev.preventDefault(); ziel.scrollIntoView({ behavior: "smooth", block: "start" }); }
      });
    });
  }
  function ergebnis() {
    var ts = themen(), h = ts[0], extra = ts.slice(1);
    melden(AUS_LINK ? "link_ergebnis" : "ergebnis", { produkte: produkteListe().map(function (p) { return p.key; }).join(","), themen: themenIds().join(",") });
    buehne.innerHTML = '<p class="nc-laden">Deine Auswertung wird geladen …</p>';
    ladeAdv(h.id).then(function (html) {
      html = html.replace("<!--NC_PERSOENLICH-->", persoenlich());
      if (extra.length) html = html.replace('<footer class="fuss">', extra.map(function (t, i) { return zweitBlock(t, i + 1); }).join("") + '<footer class="fuss">');
      buehne.innerHTML = '<div class="nca">' + html + '</div><p class="nc-nochmal"><button class="textknopf" id="nc-nochmal">Check nochmal starten</button></p>';
      linksVorbereiten(buehne);
      buehne.querySelectorAll(".nc-mehr").forEach(function (knopf) {
        knopf.onclick = function () {
          var nr = +knopf.dataset.nr, t = extra[nr - 1];
          knopf.disabled = true; knopf.textContent = "Wird geladen …";
          ladeAdv(t.id).then(function (html2) {
            html2 = html2.replace("<!--NC_PERSOENLICH-->", "").replace(/<footer class="fuss">[\s\S]*<\/footer>/, "");
            var ziel = $("nc-zweit-voll-" + nr);
            ziel.innerHTML = html2;
            linksVorbereiten(ziel);
            knopf.parentNode.removeChild(knopf);
            ziel.scrollIntoView({ behavior: "smooth", block: "start" });
            melden(AUS_LINK ? "link_thema" : "zweites_thema", { thema: t.id, nr: nr + 1 });
          }).catch(function () { knopf.disabled = false; knopf.textContent = "Nochmal versuchen"; });
        };
      });
      $("nc-nochmal").onclick = neuStarten;
    }).catch(function () {
      // Rückfall, falls das Advertorial nicht lädt: die Produkte trotzdem zeigen
      buehne.innerHTML = '<div class="nca">' + ts.map(function (t) {
        return '<section class="abschnitt creme" id="angebot-' + t.id + '"><div class="weit"><div class="wrap angebot-kopf" style="padding:0"><div class="oberzeile">Dein Thema · ' +
          esc(t.titel) + "</div><h2>" + t.h1 + "</h2><p>" + t.unterzeile + '</p></div><div class="produkte">' + t.karten.map(karteHtml).join("") + "</div></div></section>";
      }).join("") + '</div><p class="nc-nochmal"><button class="textknopf" id="nc-nochmal">Check nochmal starten</button></p>';
      linksVorbereiten(buehne);
      $("nc-nochmal").onclick = neuStarten;
    });
  }
  function neuStarten() {
    AUS_LINK = null;
    try { sessionStorage.removeItem("nc_ergebnis"); } catch (e) {}
    schritt = START; antworten = []; name = ""; zeichnen();
  }

  $("nc-layer-weiter").onclick = weiter;
  zurueck.onclick = function () { if (schritt > NAME && schritt <= MAIL) { schritt--; zeichnen(); } };
  // Aufruf über den Ergebnis-Link aus der Auswertungsmail: direkt das Ergebnis wie nach dem Check – ohne Fragen, ohne neue Meldung
  var AUS_LINK = linkLesen();
  if (AUS_LINK) { antworten = AUS_LINK.antworten; name = AUS_LINK.name; schritt = ERGEBNIS; hoechster = ERGEBNIS; }
  zeichnen();
})();
